import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-dark-grey font-semibold text-xl mt-12 mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_4 = {
  key: 0,
  class: "relative top-2"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_7 = { class: "h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6" }
const _hoisted_8 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex justify-between items-center mt-4" }
const _hoisted_11 = { class: "h-5 w-5 shrink-0 text-gray-600 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_12 = { class: "font-semibold text-sm text-gray-600" }
const _hoisted_13 = { class: "h-5 w-5 shrink-0 text-gray-600 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_14 = { class: "font-semibold text-sm text-gray-600" }
const _hoisted_15 = ["onClick", "disabled"]
const _hoisted_16 = { class: "font-semibold text-sm" }
const _hoisted_17 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "pt-[10px]"
}
const _hoisted_20 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex justify-end mt-4" }
const _hoisted_23 = ["onClick", "disabled"]
const _hoisted_24 = { class: "font-semibold text-sm" }
const _hoisted_25 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "p-4" }
const _hoisted_28 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_29 = { class: "bg-red-300 rounded-full p-3 text-white" }
const _hoisted_30 = { class: "mt-5 text-center" }
const _hoisted_31 = { class: "text-lg font-semibold text-gray-900 mb-1" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-sm text-gray-600 mb-8" }
const _hoisted_34 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_35 = {
  key: 0,
  class: "relative ml-2 text-white"
}

import {  ExclamationCircleIcon } from "@heroicons/vue/20/solid";
import { TrashIcon } from "@heroicons/vue/24/outline";
import { CheckCircleIcon } from "@heroicons/vue/20/solid";
import { createDefaultNewAdmin }  from "@/modules/main/components/constants/defaults"
import i18n from "@/plugins/i18n";
import { FormKitNode } from "@formkit/core";
import { Admin, NewAdminDetails } from "@/interfaces/admin.interface";
import { computed, onMounted, ref, watch } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useFilterStore } from "@/stores/filterStore";
import { useAdminStore } from "@/stores/adminStore";
import { useSchoolGroupStore } from "@/stores/schoolGroupsStore";
import { showToast } from '@/utils/toastUtils';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolChampionCreation',
  props: {
  showExistingChampions: {
    type: Boolean,
    default: false,
  },
  newSchoolId: {
    type: String,
    default: null,
  }
},
  setup(__props) {

const props = __props;

const { t } = useI18n();



const adminStore = useAdminStore();
const schoolStore = useSchoolStore();
const filterStore = useFilterStore();
const schoolGroupStore = useSchoolGroupStore();

const existingChampions = ref<any[]>([]);
const selectedChampions = ref<{ [key: string]: any }>({});
const existingChampionsBtn = ref(false);
const newAdmins = ref<any[]>([]);
const schoolChampions = ref<Admin[]>([]);
const deleteChampSuccess = ref(false);
const confirmChampionDeletionModal = ref(false);
const adminToDelete = ref<Admin | null>(null);
const showChampionDeleteNotification = ref(false);
const newAdmin = ref(createDefaultNewAdmin(filterStore.selectedFilters.school)) as any;
const updateSuccess = ref(false);
const responseMessage = ref("");
const buttonIsDisabled = ref(false);
const initialSchoolChampions = ref<Admin[]>([]);

const notifySuccessSaveChamp = () => {
  showToast({
    text: t('internal_tools.success.champions_message'),
    type: 'success',
    icon: CheckCircleIcon,
  })
};

const notifySuccessDeleteChamp = () => {
  showToast({
    text: t('internal_view.delete_champion_success'),
    type: 'success',
    icon: CheckCircleIcon,
  })
};

const notifyErrorDeleteChamp = () => {
  showToast({
    text: t('internal_view.delete_champion_error'),
    type: 'error',
    icon: ExclamationCircleIcon,
  })
};

const addChampion = () => {
  // Spread newAdmin to create a new instance and generate a unique _id
  newAdmins.value.push({
    ...newAdmin.value,
    _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
  });
};

const showConfirmChampionDeletionModal = (admin: Admin, e: Event) => {
  // stop page refresh
  e.preventDefault();
  confirmChampionDeletionModal.value = true;
  adminToDelete.value = admin;
};

const removeChampion = (index: number) => {
  newAdmins.value.splice(index, 1);
};

// Function to check for changes when saving
const handleNext = async () => {

  const isValidEmail = (email: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // check for new admins
  if (newAdmins.value.length > 0) {
    let successCount = 0;

    for (const admin of newAdmins.value) {
      //Check if all necessary fields are filled
      if (admin.firstName && admin.lastName && isValidEmail(admin.email)) {

        // Create a new admin object with the required properties
        admin.school = props.newSchoolId ?? schoolStore.currentSchool?._id;
       
        let res = await adminStore.createNewAdmin(admin);

        if (res?._id) {
          //push new admin to schoolChampions array
          schoolStore.updateSchoolChampion(res);
          successCount++;
        }

      } else {
        console.log("Admin data is incomplete");
      }
    }

    // Only update the response message if all admins were successfully added
    if (successCount === newAdmins.value.length) {

      // Fetch updated school structure
      await schoolStore.fetchSchoolStructure(filterStore.selectedFilters.school);
      
      // clear admin 
      newAdmins.value = [];

      // Update the school champions
      updateChampionsDetails();

      console.log("All new admins were successfully added");
      responseMessage.value = i18n.global
        .t("internal_tools.success.champions_message")
        .toString();
      updateSuccess.value = true;
      notifySuccessSaveChamp();

    } else {
      updateSuccess.value = false;
    }
  }

  //Enable button again
  buttonIsDisabled.value = false;
};

const canceldeletion = () => {
  confirmChampionDeletionModal.value = false;
};

const removeExistingChampion = async (admin: Admin, e: Event) => {
  // stop page refresh
  e.preventDefault();
  deleteChampSuccess.value = false;

  // get the selected champion's id
  const championId = admin._id;

  //  use new action to delete the champion
  if (championId) {

    const deletedChampion = await adminStore.deleteExistingChampion(championId, filterStore.selectedFilters.school, "school");
    deleteChampSuccess.value = deletedChampion;
    showChampionDeleteNotification.value = deletedChampion;
    notifySuccessDeleteChamp();
  } else {
    console.error("Champion ID is undefined");
    deleteChampSuccess.value = false;
    notifyErrorDeleteChamp();
  }

  confirmChampionDeletionModal.value = false;
};

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await schoolStore?.validateEmail(node.value as string);
    buttonIsDisabled.value = emailExists; // Disable button if email exists
    return !emailExists; // Validation passes if email does not exist
  } catch (error) {
    buttonIsDisabled.value = true; // Disable on error
    return true;
  }
};

const addExistingChampion = () => {
  existingChampionsBtn.value = true;
  existingChampions.value.push({
    _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
    firstName: '',
    lastName: '',
    email: '',
    designation: 'School Champion',
    status: 'inactive',
    roles: [],
    phoneNumber: null,
  }) as any;
};

const removeExistingMultiChampion = (index: number) => {
  existingChampions.value.splice(index, 1);
};

const championOptions = computed(() => {
  const schoolChampionIds = schoolStore.currentSchoolStructure?.schoolChampions.map(champion => champion._id) || [];
  
  if (!schoolChampionIds) return [];

  return schoolGroupStore.champions
    .filter((champion: any) => !schoolChampionIds.includes(champion._id))
    .map((champion : any) => ({
      label: `${champion.firstName} ${champion?.lastName}`,
      value: champion._id,
    })) || [];
});

const getChampionDetails = (championId :any) => {
  return schoolGroupStore.champions.find((champion : any) => champion._id === championId) || {};
};

const saveExistingChampions = async () => {
  const adminIds = Object.values(selectedChampions.value);
  console.log("Selected Admin IDs:", adminIds);
  const schoolId = schoolStore.currentSchool?._id;
  if (schoolId) {
    try {
      await schoolStore.updateAdminRoles(adminIds, schoolId);
    } catch (error) {
      alert('ERROR: Could not add existing admin.');
      console.warn(error);
    } finally {
      // Fetch updated school structure
      await schoolStore.fetchSchoolStructure(filterStore.selectedFilters.school);
      // Update the school champions
      updateChampionsDetails();
      //reset view
      existingChampionsBtn.value = false;
      existingChampions.value = [];
    }    
  }
};

const updateChampionsDetails = async () => {
  // Assign all school admins to `schoolChampions`
  if (schoolStore.currentSchoolStructure?.schoolChampions) {
    schoolChampions.value =
      schoolStore.currentSchoolStructure.schoolChampions.map((admin) => ({
        ...admin,
      }));
  }
}
const clearData = async () => {
  if (!filterStore.selectedSchool._id) return;
  updateSuccess.value = false;
  schoolChampions.value = { ...initialSchoolChampions.value };
  newAdmins.value = [];
};

onMounted(async () => {
  // Call functions onMounted to trigger the same logic as the watchers
  clearData();
  updateChampionsDetails();
});

watch(() => schoolStore.getSchoolStructure?.schoolChampions, updateChampionsDetails);

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("internal_tools.form.add_champion")), 1),
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolChampions.value, (admin) => {
        return (_openBlock(), _createElementBlock("div", {
          key: admin._id,
          class: "columns-4 mt-4"
        }, [
          _createVNode(_component_FormKit, {
            type: "text",
            label: _ctx.$t('internal_tools.form.champion_name'),
            disabled: "true",
            placeholder: _ctx.$t('internal_tools.form.champion_name'),
            modelValue: admin.firstName,
            "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event)
          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_FormKit, {
            type: "email",
            label: _ctx.$t('internal_tools.form.champion_email'),
            disabled: "true",
            placeholder: _ctx.$t('internal_tools.form.champion_email'),
            modelValue: admin.email,
            "onUpdate:modelValue": ($event: any) => ((admin.email) = $event)
          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_FormKit, {
            type: "text",
            label: _ctx.$t('internal_tools.form.champion_title'),
            disabled: "true",
            placeholder: _ctx.$t('internal_tools.form.champion_title'),
            modelValue: admin.designation,
            "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_FormKit, {
            type: "number",
            label: _ctx.$t('internal_tools.form.champion_phone'),
            disabled: "true",
            placeholder: _ctx.$t('internal_tools.form.champion_phone'),
            modelValue: admin.phoneNumber,
            "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            (_unref(adminStore).loader.deleteAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_spinner_loader)
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: ($event: any) => (showConfirmChampionDeletionModal(admin, $event)),
                  class: "mt-2 text-red-500"
                }, [
                  _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                ], 8, _hoisted_5))
          ])
        ]))
      }), 128)),
      (_unref(schoolStore).schoolStructureLoader === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-loader',
                title: 'rl loader',
                "aria-hidden": "true"
              })
            ])
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(newAdmins.value, (admin, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: admin._id,
              class: "columns-5 mt-4 mb-2 relative"
            }, [
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.form.champion_name'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.champion_name'),
                modelValue: admin.firstName,
                "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                style: { position: 'relative' },
                validation: "required",
                "messages-class": 'absolute'
              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.form.champion_surname'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                modelValue: admin.lastName,
                "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                style: { position: 'relative' },
                validation: "required",
                "messages-class": 'absolute'
              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_FormKit, {
                type: "email",
                label: _ctx.$t('internal_tools.form.champion_email'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.champion_email'),
                modelValue: admin.email,
                "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                validation: "required|email|(500)email_exists",
                style: { position: 'relative' },
                "validation-rules": { email_exists: email_exists },
                "validation-messages": {
                email_exists: _ctx.$t(
                'add_grades_class_component.step_1.email_exists'
                ),
            },
                "messages-class": 'absolute'
              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.form.champion_title'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.champion_title'),
                readonly: "",
                classes: {
                input: '!bg-gray-300 cursor-not-allowed'
            },
                modelValue: admin.designation,
                "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_FormKit, {
                type: "number",
                label: _ctx.$t('internal_tools.form.champion_phone'),
                "outer-class": "primary-select",
                placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                modelValue: admin.phoneNumber,
                "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeChampion(index)),
                  class: "mt-2 text-red-500"
                }, [
                  _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                ], 8, _hoisted_9)
              ])
            ]))
          }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-gray-600",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addChampion()))
      }, [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_rl_icon, {
            icon: 'rl-plus',
            title: 'rl plus',
            "aria-hidden": "true"
          })
        ]),
        _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
      ]),
      (props.showExistingChampions)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-gray-600",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addExistingChampion()))
          }, [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-plus',
                title: 'rl plus',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.$t('internal_tools.form.add_existing_champion')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: _normalizeClass(
            'px-[14px] py-[10px] text-white rounded-lg ' +
            (_unref(adminStore).loader.creatingAdmin ||
            buttonIsDisabled.value ||
            newAdmins.value.length === 0
                ? 'cursor-not-allowed bg-blue-300 border border-blue-300'
                : 'cursor-pointer bg-blue-600 border border-blue-600')
            ),
        onClick: _withModifiers(handleNext, ["prevent"]),
        disabled: 
            _unref(adminStore).loader.creatingAdmin ||
            buttonIsDisabled.value
            
      }, [
        _createElementVNode("h1", _hoisted_16, [
          (
                _unref(adminStore).loader.creatingAdmin
                )
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("internal_tools.form.btnSaving")), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("internal_tools.form.btnSave")), 1))
        ])
      ], 10, _hoisted_15)
    ]),
    _createVNode(_component_FormKit, {
      type: "form",
      id: "champions-form",
      actions: false
    }, {
      default: _withCtx(() => [
        (existingChampionsBtn.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Select an existing admin from another school belonging to this school group. "))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(existingChampions.value, (champion, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: champion._id,
            class: _normalizeClass(['mt-4 mb-2 relative', selectedChampions.value[champion._id] ? 'columns-4' : 'columns-1'])
          }, [
            _createVNode(_component_FormKit, {
              type: "select",
              label: _ctx.$t('internal_tools.form.champion_name'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.select_champion'),
              modelValue: selectedChampions.value[champion._id],
              "onUpdate:modelValue": ($event: any) => ((selectedChampions.value[champion._id]) = $event),
              options: championOptions.value
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "options"]),
            (selectedChampions.value[champion._id])
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 0,
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_email'),
                  placeholder: _ctx.$t('internal_tools.form.champion_email'),
                  value: (getChampionDetails(selectedChampions.value[champion._id]) as NewAdminDetails).email,
                  modelValue: selectedChampions.value[champion._id].email,
                  "onUpdate:modelValue": ($event: any) => ((selectedChampions.value[champion._id].email) = $event),
                  classes: {
            input: '!bg-gray-300 cursor-not-allowed'
        }
                }, null, 8, ["label", "placeholder", "value", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (selectedChampions.value[champion._id])
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 1,
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_title'),
                  placeholder: _ctx.$t('internal_tools.form.champion_title'),
                  value: (getChampionDetails(selectedChampions.value[champion._id]) as NewAdminDetails).designation,
                  classes: {
            input: '!bg-gray-300 cursor-not-allowed'
        },
                  readonly: ""
                }, null, 8, ["label", "placeholder", "value"]))
              : _createCommentVNode("", true),
            (selectedChampions.value[champion._id])
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 2,
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_phone'),
                  placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                  value: (getChampionDetails(selectedChampions.value[champion._id]) as NewAdminDetails).phoneNumber,
                  classes: {
            input: '!bg-gray-300 cursor-not-allowed'
        },
                  readonly: ""
                }, null, 8, ["label", "placeholder", "value"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                onClick: ($event: any) => (removeExistingMultiChampion(index)),
                class: "mt-2 text-red-500"
              }, [
                _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
              ], 8, _hoisted_21)
            ])
          ], 2))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_22, [
      (existingChampionsBtn.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(
            'px-[14px] py-[10px] text-white bg-blue-600 border border-blue-600 rounded-lg ' +
            (_unref(schoolStore).loading
                ? 'cursor-not-allowed'
                : 'cursor-pointer')
            ),
            onClick: _withModifiers(saveExistingChampions, ["prevent"]),
            disabled: 
            _unref(schoolStore).loading
            
          }, [
            _createElementVNode("h1", _hoisted_24, [
              (
                _unref(schoolStore).loading
                )
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("internal_tools.form.btnSaving")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("internal_tools.form.add_existing_champion")), 1))
            ])
          ], 10, _hoisted_23))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: confirmChampionDeletionModal.value,
      onLocalModalOpen: _cache[4] || (_cache[4] = ($event: any) => (confirmChampionDeletionModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_unref(TrashIcon), { class: "h-6 w-6" })
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_title")), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_text")) + ". ", 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              type: "button",
              class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (canceldeletion()))
            }, _toDisplayString(_ctx.$t("internal_tools.school_champions.modal.back")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "!text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap flex gap-2 justify-center w-full",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (adminToDelete.value && removeExistingChampion(adminToDelete.value, $event)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_btn")) + " ", 1),
              (_unref(adminStore).loader.deleteAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})